// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/spwn_ec/v1/legacy_portal_service.proto (package spwn.spwn_ec.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest, LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse } from "./legacy_portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.spwn_ec.v1.LegacyPortalSpwnEcService
 */
export const LegacyPortalSpwnEcService = {
    typeName: "spwn.spwn_ec.v1.LegacyPortalSpwnEcService",
    methods: {
        /**
         * 指定したイベントのライブコマース商品すべてを Shopify から取得する
         *
         * @generated from rpc spwn.spwn_ec.v1.LegacyPortalSpwnEcService.GetAllLiveCommerceProductsByEventId
         */
        getAllLiveCommerceProductsByEventId: {
            name: "GetAllLiveCommerceProductsByEventId",
            I: LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdRequest,
            O: LegacyPortalSpwnEcServiceGetAllLiveCommerceProductsByEventIdResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map